import { OWNER, USER, CRM_OBJECT } from '../constants/ReferenceTypes';
const NUMERIC_IDS_ONLY = /^\d+$/;
export const defaultIdIsValid = (referenceType, id) => {
  const isEmptyId = id === '' || id === undefined || id === null;

  if (isEmptyId) {
    return false;
  }

  const isNumberId = typeof id === 'number';

  if (isNumberId) {
    // @ts-expect-error New relic
    if (window.newrelic) {
      // @ts-expect-error New relic
      window.newrelic.addPageAction('invalid-rrl-id', {
        id,
        referenceType,
        type: 'Numeric Id'
      });
    }
  }

  switch (referenceType) {
    // these ReferenceTypes only accept numeric ids. attempting to send a
    // non-numeric id to ExternalOptions for any of these reference types will
    // cause the API call to fail with a 400 (runtime exception thrown in
    // `parseIntId`/`parseLongId`)
    case OWNER:
    case USER:
    case CRM_OBJECT:
      return NUMERIC_IDS_ONLY.test(id);

    default:
      return true;
  }
};